// extracted by mini-css-extract-plugin
export default {"MainCont":"Assembly_MainCont__IfPN3","LeftCont":"Assembly_LeftCont__ggd42","RightCont":"Assembly_RightCont__40pbp"};